import { render, staticRenderFns } from "./ResultsDetails.vue?vue&type=template&id=7f40e560"
import script from "./ResultsDetails.vue?vue&type=script&lang=js"
export * from "./ResultsDetails.vue?vue&type=script&lang=js"
import style0 from "./ResultsDetails.vue?vue&type=style&index=0&id=7f40e560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports